import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { UserLevel } from '@app/core/models/user-level';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Directive({
  selector: '[portalUserIsEndUser]',
  standalone: false,
})
export class UserIsEndUserDirective {
  constructor(
    private authService: AuthenticationService,
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  ngOnInit(): void {
    this.authService.authUser$.pipe(untilDestroyed(this)).subscribe((user) => {
      // If not cleared it could happen that some elements are displayed multiple times
      this.viewContainer.clear();

      if (user.role.level === UserLevel.EndUser) {
        this.viewContainer.createEmbeddedView(this.template);
      }
    });
  }
}
